/*
  1500 Hours · school / club bulk-order CTA  (v1 — 2026-09-02)

  A quiet line under the personalization panel on every card PDP: bulk pricing, and a mailto that
  arrives already filled in.

  WHY A MAILTO AND NOT A CART DISCOUNT. A school buying 40 cards with a different student's name and
  dates on each one CANNOT use the cart: that is forty passes through the PDP form. Every school
  order to date (Enzo, FTA, RFDS, Bankstown, Josh Dittrich, WIPP) was a draft-order invoice off the
  back of an email or a DM. So the cart-quantity discount serves the club buying fifteen IDENTICAL
  cards, and this serves the school. Two buyers, two paths, on purpose.

  The mailto body is a form. It asks for the five things every school order has needed anyway
  (who, where, how many, what's on the back, who to invoice) so the first reply is quotable instead
  of being round one of three.

  DELIBERATELY SEPARATE FROM addon-widget.js: that file owns the atomic cart write and the price
  guard. A marketing line must not be able to break it. This one is self-contained, mounts after the
  add-on panel when there is one, and degrades to the buy button otherwise.

  DEPLOY: assets/bulk-order-cta.js + a tag in theme.liquid:
     <script src="{{ 'bulk-order-cta.js' | asset_url }}" defer></script>
*/
(function () {
  'use strict';

  var EMAIL = 'crew@1500hours.com';
  // Card PDPs only. Kept as its own list rather than reading H15_ADDON_CFG so this still mounts if
  // the add-on widget fails to load (its helper-product fetch can fail; this must not care).
  var HANDLES = [
    'airport-layout-card-any-airport', 'checkride-card-custom', 'custom-card',
    'reference-card', 'airline-card'
  ];
  // The ladder, applied to the whole per-card price including add-ons (decided 2026-09-02).
  var TIERS = [
    { min: 10, off: '25%' },
    { min: 20, off: '35%' },
    { min: 50, off: '40%' }
  ];

  function handle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }
  if (HANDLES.indexOf(handle()) === -1) return;

  function mailto() {
    var subject = 'School / club order';
    var body = [
      'hi Nathan,',
      '',
      "we'd like to order cards for our school.",
      '',
      'school or club:',
      'home airport:',
      'how many cards:',
      "what goes on the back: (aircraft outline / training timeline / our logo / not sure yet)",
      'who to invoice:',
      '',
      'thanks,'
    ].join('\n');
    return 'mailto:' + EMAIL
      + '?subject=' + encodeURIComponent(subject)
      + '&body=' + encodeURIComponent(body);
  }

  function build() {
    if (document.getElementById('h15-bulk')) return;
    var host = document.createElement('div');
    host.id = 'h15-bulk';
    host.innerHTML =
      '<div class="h15b-in">' +
        '<span class="h15b-lead">buying for a school or flying club?</span>' +
        '<span class="h15b-tiers">' +
          TIERS.map(function (t) {
            return '<span class="h15b-t"><b>' + t.off + '</b> off ' + t.min + '+</span>';
          }).join('') +
        '</span>' +
        '<a class="h15b-cta" href="' + mailto() + '">get a bulk quote</a>' +
      '</div>';

    // sit under the add-on panel when there is one, else just above the buy button
    var anchor = document.getElementById('h15-addons');
    if (anchor && anchor.parentNode) { anchor.parentNode.insertBefore(host, anchor.nextSibling); return; }
    var btn = document.querySelector('product-form button[name="add"], form[action*="/cart/add"] button[name="add"]')
           || document.querySelector('button[name="add"], .product-form__submit, [data-add-to-cart]');
    if (btn && btn.parentNode) { btn.parentNode.insertBefore(host, btn); return; }
    var form = document.querySelector('product-form, form[action*="/cart/add"]');
    if (form && form.parentNode) form.parentNode.insertBefore(host, form.nextSibling);
  }

  var css = document.createElement('style');
  css.textContent =
    '#h15-bulk{margin:10px 0 16px}' +
    '.h15b-in{display:flex;flex-wrap:wrap;align-items:center;gap:8px 12px;border:1px solid #e3e3e3;border-radius:10px;padding:11px 13px}' +
    // the lead always takes its own row: at a typical PDP column width the three tiers plus the
    // link do not fit beside it, and letting it wrap on its own put the link alone on line two
    '.h15b-lead{flex:0 0 100%;font-size:13px;font-weight:600;letter-spacing:.01em}' +
    '.h15b-tiers{display:flex;flex-wrap:wrap;gap:10px;font-size:12px;color:#666}' +
    '.h15b-t b{color:#111;font-weight:600}' +
    '.h15b-cta{margin-left:auto;font-size:13px;color:#111;text-decoration:underline;text-underline-offset:3px;white-space:nowrap}' +
    '.h15b-cta:hover{opacity:.7}' +
    '@media (max-width:520px){.h15b-cta{margin-left:0}}';
  document.head.appendChild(css);

  // The theme and Globo both re-render this area after first paint, so mount on a retry and then
  // watch for the block being torn out with its parent (same failure the add-on widget guards).
  var tries = 0;
  (function mount() {
    if (document.querySelector('form[action*="/cart/add"]') || tries > 40) build();
    else { tries++; setTimeout(mount, 300); }
  })();
  var remounting = false;
  new MutationObserver(function () {
    if (remounting || document.getElementById('h15-bulk')) return;
    remounting = true;
    setTimeout(function () { remounting = false; build(); }, 150);
  }).observe(document.body, { childList: true, subtree: true });
})();
